















import { Component, Prop, Mixins } from 'vue-property-decorator';
import { FieldOptions } from '@/types/entity';
import LayoutOptionsMixin from '@/mixins/LayoutOptionsMixin';

@Component
export default class BooleanField extends Mixins(LayoutOptionsMixin) {
  @Prop()
  value!: boolean;

  @Prop()
  label!: string;

  get fieldOptions(): FieldOptions[] {
    return [
      {
        key: this.yesLabel,
        value: true,
      },
      {
        key: this.noLabel,
        value: false,
      },
    ];
  }

  onChange(value: boolean): void {
    this.$emit('input', value);
  }
}
